import QuinceError from '../error/quince-error.js';
import { getAuthConfig } from './config.js';

const AUTH_ERROR_CODES = {
    FAILED_TO_SIGN_IN: 'FAILED_TO_SIGN_IN',
    UNKNOWN: 'UNKNOWN'};
class AuthError extends QuinceError {
    notifyError(context) {
        try {
            const config = getAuthConfig();
            if (config.onError) {
                config.onError(this, {
                    context: context?.from || 'AuthError',
                    code: this.code,
                    meta: this.meta,
                    ...context
                });
            } else {
                console.error('AuthError:', this.message, {
                    code: this.code,
                    meta: this.meta,
                    context
                });
            }
        } catch (error) {
            console.error('AuthError:', this.message, {
                code: this.code,
                meta: this.meta,
                context
            });
        }
        return this;
    }
    static constructError(error, fallbackConstruction) {
        if (error instanceof AuthError) {
            return error;
        }
        const authError = error instanceof Error ? new AuthError({
            name: error.name,
            message: error.message,
            code: error.name || error?.code || AUTH_ERROR_CODES.FAILED_TO_SIGN_IN,
            meta: {
                error: error.stack
            }
        }) : new AuthError(fallbackConstruction || {
            name: error.name || 'AuthError',
            message: error.message || 'Unknown error',
            code: error.name || error?.code || AUTH_ERROR_CODES.UNKNOWN,
            meta: {
                error: error
            }
        });
        return authError;
    }
    constructor({ message, code, meta, name }){
        super({
            name: name || 'AuthError',
            message,
            data: meta
        }), this.tabName = 'Auth';
        this.code = code;
        this.meta = meta;
    }
}

export { AUTH_ERROR_CODES, AuthError as default };
//# sourceMappingURL=auth.errors.js.map
